export default "__VITE_PUBLIC_ASSET__10b0d4e6__"